// JavaScript Document

if (typeof jQuery !== "undefined") {
    /**
     * jQuery must be used due to Ninja Forms' use of it
     */
    jQuery(document).on("nfFormReady", () => { // eslint-disable-line no-undef
        const HELP_SYMBOLS = document.querySelectorAll(".nf-help");

        HELP_SYMBOLS.forEach((symbol) => {
            symbol.closest(".nf-field-label").addEventListener("click", (e) => {
                if (e.target.closest(".nf-help")) {
                    const TOOLTIP = e.target.closest(".nf-help").nextElementSibling;

                    if (TOOLTIP && TOOLTIP.classList.contains("nf-help-tooltip")) {
                        TOOLTIP.remove();
                    } else {
                        const ICON    = e.target.closest(".nf-help");
                        const TEXT    = ICON.getAttribute("data-text");

                        const WRAPPER = ICON.parentNode.classList.contains("nf-help-wrapper") ? ICON.parentNode : document.createElement("span");
                        const TOOLTIP = document.createElement("span");
                        const CONTENT = document.createElement("div");

                        /**
                         * If the wrapper doesn't exist, create it
                         */
                        if (! WRAPPER.classList.contains("nf-help-wrapper")) {
                            ICON.parentNode.insertBefore(WRAPPER, ICON);

                            WRAPPER.classList.add("nf-help-wrapper");
                            WRAPPER.style.position = "relative";
                            WRAPPER.appendChild(ICON);
                        }

                        CONTENT.classList.add("nf-user-content", "user-content", "user-content--light");
                        CONTENT.innerHTML = TEXT;

                        TOOLTIP.classList.add("nf-help-tooltip");
                        TOOLTIP.innerHTML = CONTENT.outerHTML;

                        setTimeout(() => {
                            WRAPPER.appendChild(TOOLTIP);
                        }, 100);
                    }
                }
            });
        });

        /**
         * Close tooltips when clicking outside of them
         */
        document.addEventListener("click", (e) => {
            if (! e.target.closest(".nf-help-wrapper")) {
                const TOOLTIPS = document.querySelectorAll(".nf-help-tooltip");

                TOOLTIPS.forEach((tooltip) => {
                    tooltip.remove();
                });
            }
        });
    });
}
